import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  current: {},
  projectServices: [],
  currentProjectService: {},
  periodExamples: {},
};

const servicesSlice = createSlice({
  name: "services",
  initialState,
  reducers: {
    setServicesList: (state, { payload }) => ({
      ...state,
      list: [...payload.services],
    }),
    setCurrentService: (state, { payload }) => ({
      ...state,
      current: { ...payload.service },
    }),
    setProjectServicesList: (state, { payload }) => ({
      ...state,
      projectServices: [...payload.services],
    }),
    setCurrentProjectService: (state, { payload }) => ({
      ...state,
      currentProjectService: { ...payload.service },
    }),
    setPeriodExamples: (state, { payload }) => ({
      ...state,
      periodExamples: { ...payload.examples },
    }),
    resetServicesState: () => ({
      list: [],
      current: {},
      projectServices: [],
      currentProjectService: {},
      periodExamples: {},
    }),
  },
});

export const {
  setServicesList,
  setCurrentService,
  setProjectServicesList,
  setCurrentProjectService,
  setPeriodExamples,
  resetServicesState,
} = servicesSlice.actions;

export default servicesSlice.reducer;
